<!-- =========================================================================================
  File Name: addSidebarView.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} SCHEDULE</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- NAME -->
        <vs-input label="Schedule Name" v-model="currrent_schedule.name" class="mt-5 w-full" name="item-name" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span><br>
    <!-- <div class="flex">
    <label class="vs-select--label ml-10">Day</label>
    <label class="vs-select--label ml-20">Start Time</label>
    <label class="vs-select--label ml-20">End Time</label>
  </div>
    <div class="flex mb-1" v-for="(date, index)  in currrent_schedule.dates" :key="index">
    <vs-input v-model="date.day"  name="item-mname"  />
    <flat-pickr v-model="date.start_time"  :config="configdateTimePicker" class="picker" name="start_time" />
    <flat-pickr v-model="date.end_time" :config="configdateTimePicker" class="picker" name="end_time" /><span class="danger" @click="inputRemove(index)" style="color:red">x</span>
  </div>
    <div class="flex mb-1" v-for="(date, indexd)  in newcurrrent_schedule.dates" :key="indexd">
    <vs-input v-model="date.day"  name="item-mname"  />
    <flat-pickr v-model="date.start_time"  :config="configdateTimePicker" class="picker" name="start_time" />
    <flat-pickr v-model="date.end_time" :config="configdateTimePicker" class="picker" name="end_time" /><span class="danger" @click="inputnewRemove(indexd)" style="color:red">x</span>
  </div>
  <vs-button color="primary" size="small" @click="inputAdd()">
                  <feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/>
  </vs-button> -->


       <div class="slot-fields" v-for="(date, index) in currrent_schedule.dates" :key="index">
        <br>{{index}}
      <div class="slot-fields" v-for="(item, dayindex) in date" :key="dayindex">
     <small style="color:red">{{getTime(index,dayindex,item.start_time,item.end_time)}}</small>
    <vs-row>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
    <flat-pickr v-model="item.start_time" :config="configdateTimePicker" class="timepicker" name="start_time" placeholder="Start time"/>
   </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
    <flat-pickr v-model="item.end_time" :config="configdateTimePicker" class="timepicker" name="end_time" placeholder="End time"/>
    <span class="danger" @click="inputRemove(index,dayindex)" style="color:red">x</span>
   </vs-col>
  </vs-row>
    </div>
         <div  class="slot-actions pr-2 mt-1 " style="float:right">
                <vs-button color="primary" size="small"
                           @click="inputAdd(index)">
                  <feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/>
                </vs-button>
     </div>
        </div>
      </div>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import {CREATE_SCHEDULE,UPDATE_SCHEDULE} from '@/graphql'
import vSelect from 'vue-select'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {
      }
    }
  },
  components: {
     'v-select': vSelect,
    VuePerfectScrollbar,
    flatPickr,
    moduleDataList
  },
  data () {
    return {
      newcurrrent_schedule:  {
          dates: [

            ],
        },
      currrent_schedule:
        {
          "id": "",
          "name": "",
          dates: {
            Monday: [
              {
                "start_time": "",
                "end_time": "",
              }
            ],
            Tuesday: [{
              "start_time": "",
              "end_time": "",

            }
            ],
            Wednesday: [{
              "start_time": "",
              "end_time": "",

            }
            ], Thursday: [{
              "start_time": "",
              "end_time": "",
            }
            ], Friday: [{
              "start_time": "",
              "end_time": "",
            }
            ], Saturday: [{
              "start_time": "",
              "end_time": "",
            }
            ], Sunday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          }
        },
      // currrent_schedule:
      //   {
      //     id:"",
      //     name: "",
      //     dates: [
      //         {
      //           "day":"",
      //           "start_time": "",
      //           "end_time": "",
      //         }
      //       ],
      //   },
        configdateTimePicker: {
        enableTime: true,
        noCalendar: true,
        timeFormat: "H:i",
        time_24hr: false,
        altInput: true,
        dateFormat: "H:i",
      },
      deletedschedules:[],
      dataId: null,
      dataName: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
       const {id, name, scheduledates} = JSON.parse(JSON.stringify(this.data))
       this.currrent_schedule.id = id
       this.currrent_schedule.name = name
        this.currrent_schedule.dates= {
            Monday: [],
            Tuesday: [],
            Wednesday: [],
            Thursday: [],
            Friday: [],
            Saturday: [],
            Sunday: [],
          }
       var getarry=[]
       for (let i = 0; i <scheduledates.length; i++) {
        //  delete scheduledates[i].id
         delete scheduledates[i].__typename
          getarry.push(scheduledates[i])
       }
       for (let i = 0; i < getarry.length; i++) {
          var day = getarry[i].day;
        if(day=="Monday"){
          this.currrent_schedule.dates.Monday.push(getarry[i])
        }
        if(day=="Tuesday"){
          this.currrent_schedule.dates.Tuesday.push(getarry[i])
        }
        if(day=="Wednesday"){
          this.currrent_schedule.dates.Wednesday.push(getarry[i])
        }
        if(day=="Thursday"){
          this.currrent_schedule.dates.Thursday.push(getarry[i])
        }
        if(day=="Friday"){
          this.currrent_schedule.dates.Friday.push(getarry[i])
        }
        if(day=="Saturday"){
          this.currrent_schedule.dates.Saturday.push(getarry[i])
        }
        if(day=="Sunday"){
          this.currrent_schedule.dates.Sunday.push(getarry[i])
        }
       }
       this.initValues()
      }
    }
  },
  computed: {
    schedules() {
      return this.$store.state.dataList.schedules
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.currrent_schedule.name
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    getTime(day,index,start_time,end_time){
    var space="  "
    if(start_time.toString()!='' && end_time.toString()!=''){
    if (end_time > start_time){
       return ""
    }
    else
    {
     return "End Time is Less than Start Time at " + day +  space + (index+1)
    }
    }
    },
     StatusSuccess(status) {
      this.$emit('getdata',true)
      this.$vs.notify({
        title: "Schedule",
        text: 'Schedule '+status+' Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    StatusFail() {
      this.$vs.notify({
        title: "Schedule",
        text: 'Schedule Failed to Create',
        color: 'danger',
        position: 'top-right'
      })
    },
    inputAdd(dayindex) {
      var index = this.currrent_schedule.dates[dayindex].length
      this.currrent_schedule.dates[dayindex].push({
        "start_time": "",
        "end_time": "",
      });
    },
    inputRemove(index,dayindex) {
      if(this.currrent_schedule.dates[index][dayindex].id){
        this.deletedschedules.push(this.currrent_schedule.dates[index][dayindex].id)
      }
      this.currrent_schedule.dates[index].splice(dayindex, 1);
    },
    initValues() {
      if (this.data.id) return
      this.dataId = null
     this.currrent_schedule={
          "id": "",
          "name": "",
          dates: {
            Monday: [
              {
                "start_time": "",
                "end_time": "",
              }
            ],
            Tuesday: [{
              "start_time": "",
              "end_time": "",

            }
            ],
            Wednesday: [{
              "start_time": "",
              "end_time": "",

            }
            ], Thursday: [{
              "start_time": "",
              "end_time": "",
            }
            ], Friday: [{
              "start_time": "",
              "end_time": "",
            }
            ], Saturday: [{
              "start_time": "",
              "end_time": "",
            }
            ], Sunday: [{
              "start_time": "",
              "end_time": "",
            }
            ],
          }
        },
     this.deletedschedules=[]
    },
    submitData () {
       var finalschedule=[]
    for (let i = 0; i <this.currrent_schedule.dates.Monday.length; i++) {
       var element = this.currrent_schedule.dates.Monday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
          {
            element["day"] = "Monday"
            finalschedule.push(element)
          }
    }
    for (let i = 0; i <this.currrent_schedule.dates.Tuesday.length; i++) {
       var element = this.currrent_schedule.dates.Tuesday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
          {

              element["day"] = "Tuesday"
              finalschedule.push(element)
          }
      }
    for (let i = 0; i <this.currrent_schedule.dates.Wednesday.length; i++) {
       var element = this.currrent_schedule.dates.Wednesday[i];
        if(element['start_time'] != '' && element['end_time'] != '' )
          {

                element["day"] = "Wednesday"
                finalschedule.push(element)
          }
    }
    for (let i = 0; i <this.currrent_schedule.dates.Thursday.length; i++) {
       var element = this.currrent_schedule.dates.Thursday[i];
        if(element['start_time'] != '' && element['end_time'] != '' )
          {

                 element["day"] = "Thursday"
                 finalschedule.push(element)
          }
    }
    for (let i = 0; i <this.currrent_schedule.dates.Friday.length; i++) {
       var element = this.currrent_schedule.dates.Friday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
        {

          element["day"] = "Friday"
          finalschedule.push(element)
        }
    }
     for (let i = 0; i <this.currrent_schedule.dates.Saturday.length; i++) {
       var element = this.currrent_schedule.dates.Saturday[i];
       if(element['start_time'] != '' && element['end_time'] != '' )
        {

          element["day"] = "Saturday"
          finalschedule.push(element)
        }
    }
     for (let i = 0; i <this.currrent_schedule.dates.Sunday.length; i++) {
       var element = this.currrent_schedule.dates.Sunday[i];
      if(element['start_time'] != '' && element['end_time'] != '' )
       {
         element["day"] = "Sunday"
         finalschedule.push(element)
       }
    }
    var error=0
    checkSchedule(finalschedule);
    function checkSchedule(finalschedule){
      for (let i = 0; i < finalschedule.length; i++) {
      if (finalschedule[i].end_time <= finalschedule[i].start_time){
         error++
      }
    }
    }
      this.$validator.validateAll().then(result => {
        if (result && error==0) {
          if (this.currrent_schedule.id !== "" && this.currrent_schedule.id>= 0) {
          var newschedule=[]
          for (let i = 0; i <finalschedule.length; i++) {
           if(!finalschedule[i].id){
             newschedule.push(finalschedule[i])
           }
         }
       finalschedule=finalschedule.filter(function(item) {
        if(item.id)
        {
         return true
        }
        else{
          return false
        }
        })
        this.$apollo
          .mutate({
           mutation: UPDATE_SCHEDULE,
          variables: {
          id:this.currrent_schedule.id,
          name:this.currrent_schedule.name,
          status:true,
          scheduledates: {
          update:finalschedule,
          create:newschedule,
          delete:this.deletedschedules,
          },
          }
        })
        .then(response => {
          if (response){
            this.StatusSuccess("UPDATE")
          }
        }) .catch(error => {
           this.StatusFail()
          console.log(error)
      });
          }
        if(this.currrent_schedule.id=="") {
          if(finalschedule.length>0){
          this.$apollo
          .mutate({
           mutation: CREATE_SCHEDULE,
          variables: {
          name:this.currrent_schedule.name,
          status:true,
          scheduledates: {
          create:finalschedule
          },
          }
        })
        .then(response => {
          if (response){
            this.StatusSuccess("Created")

          }
        }) .catch(error => {
           this.StatusFail()
      });
    }
          }
          this.$emit('closeSidebar')
          this.currrent_schedule.id=''
          this.deletedschedules=[]
          this.initValues()
        }
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.slot-actions{
  clear: both;
  text-align: right;
  margin: 5px;
}
.flatpickr-input{
  width: 50%;
}
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
<style>
.timepicker{
  width: 100%;
}

</style>
